import { Dispatch } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from 'src/common/components/Buttons';
import { FiArrowRight } from 'react-icons/fi';
import { Wrapper } from './Common';
import { DisplayState, AssessmentMetaData } from './types';
import { mobileBreakpoint } from './mobileBreakpoint';
import sageLogo from 'src/assets/sage_logo.webp';

const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 4em;
  padding-left: 2.5em;
  h3 {
    color: #475467;
    font: 500 1.75rem/2.125rem Inter, sans-serif;
    margin-bottom: 0.25em;
  }
  h1 {
    color: #101828;
    font: 700 3rem/3.625rem Inter, sans-serif;
  }
  h5 {
    max-width: 60%;
    color: #475467;
    font: 500 1.25rem/1.5rem Inter, sans-serif;
    strong {
      font-weight: 700;
      color: #101828;
    }
  }
  @media ${mobileBreakpoint.mobile} {
    padding-top: 0em;
    padding-left: 1.5em;
    position: relative;
    h3 {
      font-size: 1em;
    }
    h1 {
      font-size: 28px;
    }
    h5 {
      font-size: 16px;
      max-width: 90%;
      width: 90%;
      line-height: 24px;
      margin: 20px 0;
    }
  }
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 4.5em;
  padding-left: 2.5em;

  button {
    width: 7em;
    font-size: 18px;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: ${props => props.theme.main.black};
  }
  .logo-container {
    padding-right: 50px;
  }
  .logo {
    width: 185px;
    height: 65px;
    object-fit: contain;
  }
  @media ${mobileBreakpoint.mobile} {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding-bottom: 1.5em;
    padding-left: 1.5em;
    button {
      width: 95%;
      margin-top: 1.5em;
    }
  }
`;
const Ellipse = styled.div`
  width: 50%;
  height: 100%;
  border-radius: 50%;
  background-color: ${props => props.theme.green.extraLight};
  position: absolute;
  right: 0;
  @media (max-height: 653px) {
    height: 10em;
    top: -30px;
  }
  @media (max-height: 600px) {
    display: none;
  }
`;
const EllipseContainer = styled.div`
  display: none;
  @media ${mobileBreakpoint.mobile} {
    margin-left: auto;
    display: flex;
    position: relative;
    height: clamp(100px, 30vh, 200px);
    width: 100vw;
  }
`;
const OneMoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  height: 100%;
  position: relative;
  overflow: hidden;
  &:after {
    top: -180px;
    right: -50px;
    content: '';
    width: 450px;
    height: 450px;
    border-radius: 50%;
    // background-color: ${props => props.theme.green.extraLight};
    position: absolute;
  }
  @media ${mobileBreakpoint.mobile} {
    &:after {
      display: none;
    }
  }
`;
const ActionButton = styled(PrimaryButton)`
  margin-right: 5rem;
  svg {
    margin-left: 6px;
  }
`;

const Greeting = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${mobileBreakpoint.mobile} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

type Props = {
  clientName?: string;
  setDisplayState?: Dispatch<DisplayState>;
  metadata?: AssessmentMetaData;
  publicAssessment?: boolean;
};

const getFullName = (details: any) => {
  const { firstName, lastName } = details ?? {};
  return `${firstName} ${lastName}`;
};

function Intro({
  clientName = 'Iain Gillespie',
  setDisplayState,
  metadata,
  publicAssessment = false,
}: Props) {
  if (!publicAssessment && metadata && !Object.keys(metadata).length)
    return <></>;

  return (
    <Wrapper width="100%">
      <OneMoreWrapper>
        <Header>
          <Greeting>
            <div>
              <h3>Hello</h3>
              {!publicAssessment && (
                <h1>{getFullName(metadata?.clientDetails)}</h1>
              )}
            </div>
          </Greeting>
          {!publicAssessment ? (
            <h5>
              Your financial advisor{' '}
              <strong>{getFullName(metadata?.advisorDetails)}</strong> has sent
              you this assessment to help personalize your financial future.
            </h5>
          ) : (
            <h5>
              {/* <strong>{getFullName(metadata?.advisorDetails)}</strong>{' '}
              {metadata?.firmName ? (
                <>
                  at <strong>{metadata?.firmName}</strong>
                </>
              ) : (
                <></>
              )}{' '} */}
              {`We're sharing this assessment to help you quickly learn about what
              makes you unique.`}
            </h5>
          )}
        </Header>
        <EllipseContainer>
          <Ellipse />
        </EllipseContainer>
        <ActionContainer>
          <div className="logo-container">
            <img className="logo" src={sageLogo} alt="sage-logo" />
          </div>
          <ActionButton onClick={() => setDisplayState?.('QUESTION_MODE')}>
            Start
            <FiArrowRight />
          </ActionButton>
        </ActionContainer>
      </OneMoreWrapper>
    </Wrapper>
  );
}

export default Intro;
